export default {
  direct: 'Direkt',
  stops: 'Stopps',
  stop: 'Stopp',
}
